import { render, staticRenderFns } from "./MyFavoritesCard.vue?vue&type=template&id=d41219e4&scoped=true&"
import script from "./MyFavoritesCard.vue?vue&type=script&lang=js&"
export * from "./MyFavoritesCard.vue?vue&type=script&lang=js&"
import style0 from "./MyFavoritesCard.vue?vue&type=style&index=0&id=d41219e4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d41219e4",
  null
  
)

export default component.exports